import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-ink-950/80 py-6">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-2 px-4 text-xs text-ink-200 sm:flex-row sm:justify-between sm:px-6 lg:px-8">
        <span className="font-semibold text-white">썰모 사이트 0.2.5 by Codex</span>
        <span>ⓒ SSULMO. All Rights Reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
